export default "__VITE_ASSET__DYpMOKb0__"